import { Injectable } from '@angular/core';
import {NgbModal, NgbModalOptions} from '@ng-bootstrap/ng-bootstrap';

@Injectable({
  providedIn: 'root'
})
export class ModalService {

  constructor(private ngbModal: NgbModal) { }

  openNgbModal(content: any, options: NgbModalOptions = {}) {
    options.backdrop = 'static';
    return this.ngbModal.open(content, options);
  }

  dismissAllNgbModals() {
    this.ngbModal.dismissAll();
  }
}
